<template>
    <div class=''>
        <div class="contract-box" v-html="artcCntnt"></div>
         <div class="spaceCenter">
            <a-button class="btn-blue-line btn-big" style="margin:30px 10px;" @click="goBack()">返回</a-button>
        </div> 
    </div>
</template>

<script>
    import {borrowedContractList} from "@/api/borrow.js"
    export default {
        props:{
            params:{
                type:Object,
                default:function(){
                    return {};
                }
            }
        },
        name:"goldFinancingAgreement",
        components: {},
        data() {
            return {
                artcCntnt:"",
            };
        },
        computed: {},
        methods: {
            goBack(){
                this.$emit("changeComp",{
                    comp:"goldFinancingRequest"
                })
            }
        },
        created() {
            if(this.params&&this.params.params){
                borrowedContractList(this.params.params,true).then(res => {
                    this.artcCntnt = res.data.artcCntnt;
                })
            }
        },
        watch:{
            params(){
                if(this.params&&this.params.params){
                    borrowedContractList(this.params.params,true).then(res => {
                        this.artcCntnt = res.data.artcCntnt;
                    })
                }
            }
        }
    }
</script>
<style scoped>
.contract-box{
    width: 86%;
    height: calc(100vh - 300px);
    overflow: auto;
    margin:0 auto;
    border: #e9ebee 1px solid;
    margin-top: 30px;
    padding: 20px;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
}
</style>


// WEBPACK FOOTER //
// src/pages/circulation/gold-financing/goldFinancingAgreement.vue